/*
  Fetches and injects "you may also like" recommendations into the cart drawer.
  Triggered whenever the drawer opens (not on a viewport-intersection check,
  since the drawer slides in from off-screen and standard IntersectionObserver
  visibility logic doesn't apply well to a sliding side panel).
*/
(function () {
  'use strict';

  function loadRecommendations(slot) {
    var url = slot.getAttribute('data-cart-recommendations-url');
    if (!url || slot.dataset.loaded === 'true') return;
    slot.dataset.loaded = 'true';

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          slot.innerHTML = recommendations.innerHTML;
          slot.className = 'cart-recommendations';
        }
      })
      .catch(function () {
        // Fail silently: checkout still works fine without this widget.
      });
  }

  function checkDrawer(cartDrawerEl) {
    if (!cartDrawerEl.classList.contains('active')) return;
    var slot = cartDrawerEl.querySelector('.cart-recommendations-slot');
    if (slot) loadRecommendations(slot);
  }

  function init() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    checkDrawer(cartDrawerEl);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        checkDrawer(cartDrawerEl);
      });
      observer.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
